import {message, Tooltip} from 'antd';
import React, {useState} from 'react';
import iconAdd from '../../../../assets/images/icon_add.png';
import defaultCharacterImg from '../../../../assets/images/default_character.png';
import iconInProd from '../../../../assets/images/icon_in_prod.png';
import {clickHeaderCharacterChooseLog, clickHeaderCharacterUploadLog} from '../../../../log/ubcLog';

const CharacterItem = props => {
    const {
        name,
        url,
        vis_figure_id: id,
        figure_id: figureId,
        live_figure_id: liveFigureId,
        status_msg: desc,
        status,
        type,
        onSelect,
        setRecreateItem,
        setShowCreateCharacter,
        selectedCharacter,
        use_status: useStatus
    } = props;

    const [materialSize, setMaterialSize] = useState({});

    const reCreate = e => {
        e.stopPropagation();
        setRecreateItem({
            name,
            figure_id: figureId,
            live_figure_id: liveFigureId
        });
        setShowCreateCharacter('reCreate');
    };

    const handleOnload = e => {
        try {
            const {width, height} = e.target;
            setMaterialSize({width, height});
        }
        catch (e) {
            // noop
        }
    };

    const onClick = e => {
        if (status === -2) {
            message.info('数字人制作失败');
            return;
        }

        if (status === 1) {
            message.info('数字人制作中，暂不可用');
            return;
        }

        onSelect({...props, materialSize, id});
        clickHeaderCharacterChooseLog();
    };

    const openCharacter = () => {
        clickHeaderCharacterUploadLog();
        window.open(`${window.location.href.replace('/editor', '/character')}`);
    };
    if (type === 'add') {
        return (
            <div className="digital-resource-lib-item character-item" onClick={openCharacter}>
                <div className="character-item-imgwrapper add">
                    <img className="icon icon-add" src={iconAdd} />
                </div>
                <div className="character-item-name add">定制我的数字人</div>
            </div>
        );
    }

    return (
        <div
            className="digital-resource-lib-item character-item"
            onClick={onClick}
        >
            <div className={`character-item-imgwrapper ${id === selectedCharacter ? 'character-item-imgwrapper-active' : ''}`}>
                <img className="character-item-img" src={url || defaultCharacterImg} onLoad={handleOnload} />
                {status !== 3 ? (
                    <p className={`character-item-tips status-${status}`}>
                        {desc}
                        {status === -2 && <Tooltip title={<span>{props.reason}</span>} placement="bottom"> <img style={{width: '16px', height: '16px', verticalAlign: 'middle'}} src={iconInProd} /></Tooltip> }
                        {/* {status === -2 && <span className="recreate" onClick={reCreate}>重新制作</span>} */}
                    </p>
                ) : null}
                {+useStatus === 1 ? (
                    <p className="character-item-mask">
                        <span className="character-item-mask-status">开播中</span>
                        {/* <span>{name}正在开播中</span> */}
                    </p>
                ) : null}
            </div>
            <div className="character-item-name">{name}</div>
        </div>
    );
};

export default CharacterItem;
